













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { preferred_language } from "@/config/languags.config.json";
import { ICategory, IProductCard } from "@/@types/menu/menu/menu";

import AddDishForm from "@/components/forms/menu/add-dish-form.vue";
import MainDemo from "@/components/demo/main-demo.vue";
import MenuDemo from "@/components/demo/menu/menu-demo.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

@Component({
  components: {
    AddDishForm,
    MainDemo,
    MenuDemo,
    LanguagesButtons,
    ButtonBack,
  },
})
export default class ChangeDish extends Vue {
  @Prop({ type: Array, default: () => [] }) categoryList!: Array<ICategory>;
  @Prop({ type: Array, default: () => [] }) menuList!: Array<IProductCard>;
  @Prop({ type: String, default: "" }) activeBar!: string;
  @Prop({ type: String, default: null }) id!: string;

  show = false;
  alertMessage = "";
  variant = "danger";
  menuItem: IProductCard | null = null;
  languageDemo = preferred_language;

  addNewDish(id: string, dish: IProductCard): void {
    if (!dish) return;
    this.$emit("changeProduct", id, dish);
    this.$router.push({ name: "MenuList" });
  }

  @Watch("id")
  start(): void {
    if (!this.id) return;
    const dish = this.menuList.find((el) => el._id == this.id);
    if (!dish) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      return;
    }
    this.menuItem = Object.assign({}, dish);
  }

  mounted(): void {
    this.start();
    this.$nextTick(() => (this.show = true));
  }
}
